import styled, { css, keyframes } from "styled-components";

/*
 * Stepper toka kupovine, v2 s.9.1/s.13.6:
 * tanka traka bez kutije; završen korak --brand outline + check
 * (ne zeleno, zelena je semantika statusa, stepper je navigacija).
 */

const fadeDown = keyframes`
  from { opacity: 0; transform: translateY(-12px); }
  to { opacity: 1; transform: translateY(0); }
`;

const activePulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255, 107, 53, 0.45); }
  100% { box-shadow: 0 0 0 9px rgba(255, 107, 53, 0); }
`;

export const StepperWrapper = styled.div`
  margin: 0 auto 2rem;
  max-width: 640px;
  padding: 0.5rem 0;
  animation: ${fadeDown} 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const StepperList = styled.ol`
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0.5rem;
`;

export const StepItem = styled.li`
  display: flex;
  align-items: center;
  flex: 1;

  &:last-of-type {
    flex: 0 0 auto;
  }
`;

export const StepDot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  min-width: 60px;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
`;

export const StepCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
  border: 2px solid;
  transition: all 0.2s ease;

  background: ${({ $state }) =>
    $state === "active" ? "var(--brand)" : "transparent"};

  color: ${({ $state }) =>
    $state === "completed"
      ? "var(--brand)"
      : $state === "active"
        ? "#ffffff"
        : "var(--text-muted)"};

  border-color: ${({ $state }) =>
    $state === "inactive" ? "var(--border-strong)" : "var(--brand)"};

  /* aktivan korak jednom "pulsira" pri prelasku na njega */
  ${({ $state }) =>
    $state === "active" &&
    css`
      animation: ${activePulse} 0.6s ease-out;
    `}

  svg {
    stroke-width: 3;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const StepLabel = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${({ $state }) =>
    $state === "inactive" ? "var(--text-muted)" : "var(--brand)"};
  text-align: center;
  white-space: nowrap;
`;

export const StepConnector = styled.div`
  flex: 1;
  height: 1px;
  margin: 0 0.75rem;
  background: ${({ $completed }) =>
    $completed ? "rgba(255, 107, 53, 0.45)" : "var(--border)"};
  transition: background 0.3s ease;
  margin-bottom: 1.35rem;
`;

/* Zadržan export (helper rečenica se više ne renderuje, v2 s.9.1) */
export const StepperHelper = styled.p`
  display: none;
`;
